import React from 'react';
import { FakeLink } from '../FakeLink';
import { LinkType } from '../../containers/Link/types';

export const LinkContext = React.createContext<LinkType>(FakeLink);

export const LinkProvider = LinkContext.Provider;
